import DialogActions, { type DialogActionsProps } from '@mui/material/DialogActions'
import React from 'react'

const HHDialogActions: React.FC<DialogActionsProps> = ({ sx, children }) => (
  <DialogActions sx={{ px: 3, paddingBottom: 2, paddingTop: 1, ...sx }}>{children}</DialogActions>
)

export default HHDialogActions
